import React from "react";
import Select from "react-select";
import { array, bool, shape, string, func, object } from "prop-types";
import DropdownIndicator from "./drop-down-indicator";
import Option from "./option";

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

/**
 * Custom styles to change the look and feel of the react select components
 */
const customStyles = {
  valueContainer: (provided, state) => ({
    ...provided,
    maxWidth: "150px",
    borderRadius: "8px",
    backgroundColor: state.hasValue ? "#0627F3" : "#FFFFFF",
    textTransform: "capitalize",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
    paddingLeft: "10px",
  }),
  control: (base, state) => ({
    ...base,
    borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    border: "none",
    boxShadow: "none",
    outline: "none",
    width: "100%",
    float: "right",
    backgroundColor: "#fff",
    paddingRight: "17px",
  }),
  menu: (base, state) => ({
    ...base,
    borderRadius: 8,
    marginTop: "45px",
    width: "100%",
    zIndex: 9999999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#F8F9FF" : "#FFFF",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: state.isSelected ? "" : "#F8F9FF",
      color: "#000",
    },
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    borderRadius: "8px",
    maxHeight: "200px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fff",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transform: state.selectProps.menuIsOpen ? "rotate(90deg)" : "rotate(0)",
    transition: "250ms",
  }),
  clearIndicator: (base, state) => ({
    ...base,
    padding: "8px 0px 8px 8px",
  }),
};

const SingleSelect = ({
  options,
  field = {
    value: undefined,
    onChange: () => {},
    onBlur: () => {},
    name: "",
    ref: () => {},
  },
  defaultValue,
  isDisabled = false,
}) => {
  return (
    <div className="select__container">
      <span data-toggle="popover" data-trigger="focus">
        <Select
          options={options}
          components={{
            // replace the option component with a custom one
            Option,
            // remove the separator
            IndicatorSeparator: () => null,
            // replace the dropdown indicator with a custom one
            DropdownIndicator,
          }}
          defaultValue={defaultValue}
          formatGroupLabel={formatGroupLabel}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          styles={customStyles}
          isSearchable={false}
          {...field}
          placeholder=""
          isClearable={true}
          isDisabled={isDisabled}
        />
      </span>
    </div>
  );
};

SingleSelect.propTypes = {
  options: array.isRequired,
  field: shape({
    value: object,
    onChange: func,
    onBlur: func,
    ref: func,
    name: string,
  }),
  isDisabled: bool.isRequired,
};

export default SingleSelect;
